import * as React from 'react';
import { connect, DispatchProp } from 'react-redux';
import { Features, GetApp, Presentation } from './sections';
import * as App from 'application';

export interface ILandingViewProps extends DispatchProp {
	isShowLogin?: boolean;
	isShowSignUp?: boolean;
	queryValues?: any;
}


class LandingView extends React.Component<ILandingViewProps> {
	componentDidMount() {
		let cte = "url";
		if (this.props.queryValues && this.props.queryValues.cte) {
			cte = this.props.queryValues.cte;
		}
		if (this.props.isShowLogin === true) {
			App.Authentication.openLogin(this.props.dispatch, cte);
		} else if (this.props.isShowSignUp === true) {
			App.Authentication.openSignUp(this.props.dispatch, cte);
		}
	}
	render() {
		const onOpenSignUp = (ctaButtonText) => App.Authentication.openSignUp(this.props.dispatch, ctaButtonText);
		return (<React.Fragment>
			<Presentation />
			<GetApp signInSignUp={(ctaButtonText) => onOpenSignUp(ctaButtonText)} />
			<Features signInSignUp={(ctaButtonText) => onOpenSignUp(ctaButtonText)} />
		</React.Fragment>);
	}
};

export const Landing = connect()(LandingView)



// WEBPACK FOOTER //
// ./src/components/presentational/views/Landing/index.tsx